export const OtpInput = ({ label, value, onChange, maxLength = 6 }) => (
    <div>
        <label className="block text-sm font-medium text-gray-300 mb-2">{label}</label>
        <input
            type="number"
            value={value}
            onChange={(e) => {
                const val = e.target.value;
                if (val.length <= maxLength) onChange(val);
            }}
            className="w-full bg-gray-900 border border-gray-700 rounded-lg px-4 py-3 text-white pr-10"
        />
    </div>
);